import React, { useState } from "react";
import "./index.css"; // Stil dosyası
import { useTranslation } from "react-i18next";
function Contact() {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [status, setStatus] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://smartmarket-info-bot-od4g.onrender.com/userInfo/codepro", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ name, email, message })
      });

      if (response.ok) {
        setStatus(t("contactStatus1"));
        setName("");
        setEmail("");
        setMessage("");
      } else {
        setStatus(t("contactStatus2"));
      }
    } catch (error) {
      console.error(error);
      setStatus(t("contactStatus3"));
    }
  };

  return (
    <div className="contact">
      
      <div className="navbar" />
      <div className="contact-container">
        <div className="contact-box">
          <h2>CONTACT ME</h2>
          <p>{t("TextContactME")}</p>
          <div className="contact-info">
            <h3>Address</h3>
            <p>Altindag, Ankara, Türkiye</p>
            <h3>Phone</h3>
            <p>+90 545 679 90 03</p>
            <h3>Email</h3>
            <p>Abdurazzoqovdavronbek3@gmail.com</p>
          </div>
        </div>
        <div className="form-box">
          <h4>Contact me</h4>
          <form onSubmit={handleSubmit}>
            <div className="form-floating">
              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
              />
              <label>Name</label>
            </div>
            <div className="form-floating">
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
              />
              <label>Email</label>
            </div>
            <div className="form-floating">
              <input
                type="tel"
                className="form-control"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                placeholder="Phone Number"
              />
              <label>Phone Number</label>
            </div>
            <div className="form-floating">
              <textarea
                className="form-control"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Leave a comment here"
              ></textarea>
              <label>Comments</label>
            </div>
            <button className="btn btn-primary" onClick={handleSubmit} >
              Send Message
            </button>
            {status && <p className="status-msg">{status}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
